module.exports = "/images/Homepage-What We DoM.jpg";